// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rooms-list .muted {
  color: #64748b;
  font-size: 0.8rem;
  margin-top: 2px;
}
.rooms-list .p-datatable {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);
}
.rooms-list .p-datatable-thead > tr > th {
  background: #f9fafb;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}
.rooms-list .p-datatable-tbody > tr > td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.rooms-list .p-datatable-tbody > tr:last-child > td {
  border-bottom: 0;
}
.rooms-list tr.clickable {
  cursor: pointer;
  transition: background 0.12s;
}
.rooms-list tr.clickable:hover {
  background: #f0fdfa;
}
.rooms-list .room-cell {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}
.rooms-list .thumb {
  flex: none;
  width: 64px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  background: #ccfbf1;
  color: #0f766e;
  font-size: 1.2rem;
}
.rooms-list .thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.rooms-list .room-name {
  font-weight: 600;
  color: #0f172a;
}
.rooms-list .capacity {
  font-weight: 600;
  color: #0f172a;
}
.rooms-list .capacity i {
  margin-right: 6px;
  color: #64748b;
}
.rooms-list .price {
  font-weight: 700;
  font-size: 1.02rem;
  color: #0f172a;
}
.rooms-list .price .muted {
  font-weight: 400;
  margin-left: 4px;
}
.rooms-list .bands {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.rooms-list .band {
  display: inline-flex;
  gap: 4px;
  padding: 3px 9px;
  font-size: 0.78rem;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}
.rooms-list .band b {
  color: #0f766e;
}
.rooms-list .band.free b {
  color: #64748b;
}
.rooms-list .actions-col {
  width: 110px;
  text-align: right;
  white-space: nowrap;
}
.rooms-list .actions-col .p-button + .p-button {
  margin-left: 0.4rem;
}
.rooms-list .empty {
  text-align: center;
  padding: 2.5rem 1rem !important;
  color: #64748b;
}
@media (max-width: 768px) {
  .rooms-list .bands {
    display: none;
  }
}
/*# sourceMappingURL=manage-rooms.component.css.map */`, "",{"version":3,"sources":["webpack://./manage-rooms.component.less","webpack://./src/app/rooms/manage-rooms/manage-rooms.component.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;EACA,iBAAA;EACA,eAAA;ACFJ;ADFA;EAQI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;ACHJ;ADTA;EAgBI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gCAAA;ACJJ;ADnBA;EA2BI,oBAAA;EACA,gCAAA;EACA,sBAAA;ACLJ;ADxBA;EAiCI,gBAAA;ACNJ;AD3BA;EAqCI,eAAA;EACA,4BAAA;ACPJ;ADSI;EACE,mBAAA;ACPN;ADlCA;EA8CI,aAAA;EACA,mBAAA;EACA,WAAA;ACTJ;ADvCA;EAoDI,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;ACVJ;ADpDA;EAiEM,WAAA;EACA,YAAA;EACA,iBAAA;ACVN;ADzDA;EAwEI,gBAAA;EACA,cAAA;ACZJ;AD7DA;EA6EI,gBAAA;EACA,cAAA;ACbJ;ADjEA;EAiFM,iBAAA;EACA,cAAA;ACbN;ADrEA;EAuFI,gBAAA;EACA,kBAAA;EACA,cAAA;ACfJ;AD1EA;EA4FM,gBAAA;EACA,gBAAA;ACfN;AD9EA;EAkGI,aAAA;EACA,eAAA;EACA,QAAA;ACjBJ;ADnFA;EAwGI,oBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AClBJ;AD7FA;EAkHM,cAAA;AClBN;ADqBI;EACE,cAAA;ACnBN;ADnGA;EA2HI,YAAA;EACA,iBAAA;EACA,mBAAA;ACrBJ;ADxGA;EAgIM,mBAAA;ACrBN;AD3GA;EAqII,kBAAA;EACA,+BAAA;EACA,cAAA;ACvBJ;AD2BA;EACE;IACE,aAAA;ECzBF;AACF;AACA,qDAAqD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.rooms-list {\n  .muted {\n    color: #64748b;\n    font-size: 0.8rem;\n    margin-top: 2px;\n  }\n\n  .p-datatable {\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n  }\n\n  .p-datatable-thead > tr > th {\n    background: #f9fafb;\n    color: #64748b;\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    padding: 0.85rem 1rem;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .p-datatable-tbody > tr > td {\n    padding: 0.9rem 1rem;\n    border-bottom: 1px solid #f1f5f9;\n    vertical-align: middle;\n  }\n\n  .p-datatable-tbody > tr:last-child > td {\n    border-bottom: 0;\n  }\n\n  tr.clickable {\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover {\n      background: #f0fdfa;\n    }\n  }\n\n  .room-cell {\n    display: flex;\n    align-items: center;\n    gap: 0.9rem;\n  }\n\n  .thumb {\n    flex: none;\n    width: 64px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    border-radius: 8px;\n    background: #ccfbf1;\n    color: #0f766e;\n    font-size: 1.2rem;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .room-name {\n    font-weight: 600;\n    color: #0f172a;\n  }\n\n  .capacity {\n    font-weight: 600;\n    color: #0f172a;\n\n    i {\n      margin-right: 6px;\n      color: #64748b;\n    }\n  }\n\n  .price {\n    font-weight: 700;\n    font-size: 1.02rem;\n    color: #0f172a;\n\n    .muted {\n      font-weight: 400;\n      margin-left: 4px;\n    }\n  }\n\n  .bands {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  .band {\n    display: inline-flex;\n    gap: 4px;\n    padding: 3px 9px;\n    font-size: 0.78rem;\n    color: #334155;\n    background: #f8fafc;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n\n    b {\n      color: #0f766e;\n    }\n\n    &.free b {\n      color: #64748b;\n    }\n  }\n\n  .actions-col {\n    width: 110px;\n    text-align: right;\n    white-space: nowrap;\n\n    .p-button + .p-button {\n      margin-left: 0.4rem;\n    }\n  }\n\n  .empty {\n    text-align: center;\n    padding: 2.5rem 1rem !important;\n    color: #64748b;\n  }\n}\n\n@media (max-width: 768px) {\n  .rooms-list .bands {\n    display: none;\n  }\n}\n",".rooms-list .muted {\n  color: #64748b;\n  font-size: 0.8rem;\n  margin-top: 2px;\n}\n.rooms-list .p-datatable {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n}\n.rooms-list .p-datatable-thead > tr > th {\n  background: #f9fafb;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.rooms-list .p-datatable-tbody > tr > td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n.rooms-list .p-datatable-tbody > tr:last-child > td {\n  border-bottom: 0;\n}\n.rooms-list tr.clickable {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.rooms-list tr.clickable:hover {\n  background: #f0fdfa;\n}\n.rooms-list .room-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n}\n.rooms-list .thumb {\n  flex: none;\n  width: 64px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 8px;\n  background: #ccfbf1;\n  color: #0f766e;\n  font-size: 1.2rem;\n}\n.rooms-list .thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.rooms-list .room-name {\n  font-weight: 600;\n  color: #0f172a;\n}\n.rooms-list .capacity {\n  font-weight: 600;\n  color: #0f172a;\n}\n.rooms-list .capacity i {\n  margin-right: 6px;\n  color: #64748b;\n}\n.rooms-list .price {\n  font-weight: 700;\n  font-size: 1.02rem;\n  color: #0f172a;\n}\n.rooms-list .price .muted {\n  font-weight: 400;\n  margin-left: 4px;\n}\n.rooms-list .bands {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.rooms-list .band {\n  display: inline-flex;\n  gap: 4px;\n  padding: 3px 9px;\n  font-size: 0.78rem;\n  color: #334155;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n}\n.rooms-list .band b {\n  color: #0f766e;\n}\n.rooms-list .band.free b {\n  color: #64748b;\n}\n.rooms-list .actions-col {\n  width: 110px;\n  text-align: right;\n  white-space: nowrap;\n}\n.rooms-list .actions-col .p-button + .p-button {\n  margin-left: 0.4rem;\n}\n.rooms-list .empty {\n  text-align: center;\n  padding: 2.5rem 1rem !important;\n  color: #64748b;\n}\n@media (max-width: 768px) {\n  .rooms-list .bands {\n    display: none;\n  }\n}\n/*# sourceMappingURL=manage-rooms.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
